import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || String(error) };
  }

  componentDidCatch(error, info) {
    // Deja el error visible en consola para diagnóstico (navegadores antiguos).
    // eslint-disable-next-line no-console
    console.error("ClinPed error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", background: "#FDFBF7",
          color: "#3D405B", padding: "24px", fontFamily: "system-ui, -apple-system, sans-serif", textAlign: "center" }}>
          <h1 style={{ fontSize: "22px", fontWeight: 700, marginBottom: "10px" }}>Ocurrió un problema al cargar la app</h1>
          <p style={{ maxWidth: 460, opacity: 0.8, marginBottom: 18 }}>
            Si usas un navegador antiguo (Safari 14 o anterior), actualiza tu navegador o macOS.
            También puedes intentar recargar la página.
          </p>
          <button data-testid="error-reload-btn" onClick={() => { window.location.href = "/"; }}
            style={{ background: "#C1654F", color: "#fff", border: "none", borderRadius: "14px",
              padding: "12px 22px", fontWeight: 700, cursor: "pointer" }}>
            Recargar
          </button>
          {this.state.message && (
            <pre style={{ marginTop: 22, fontSize: 11, opacity: 0.55, maxWidth: 520, whiteSpace: "pre-wrap" }}>
              {this.state.message}
            </pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
